import { StatusBar } from "expo-status-bar";
import React, { useContext, useState } from "react";
import {
  Dimensions,
  Image,
  Keyboard,
  KeyboardAvoidingView,
  Linking,
  Platform,
  SafeAreaView,
  ScrollView,
  StyleSheet,
  Text,
  TouchableWithoutFeedback,
  View,
} from "react-native";
import BouncyCheckbox from "react-native-bouncy-checkbox";
import { Masks } from "react-native-mask-input";
import BetterAlert from "../../components/BetterAlert";
import Button from "../../components/Button";
import Loading from "../../components/Loading";
import MessageTypeModal from "../../components/MessageTypeModal";
import CaixaTextoInputIcone from "../../components/TextBoxIcon";
import { AuthContext } from "../../contexts/auth";
import Validade from "../../helpers/validate";
import { Register } from "../../services/Api/login";
import { urlPrivacity, urlTermsOfUse } from "../../services/Config";
import { Encrypt } from "../../services/Crypt";
import * as Colors from "../../styles/colors";
import * as Fonts from "../../styles/typography";
import { IS_WEB } from "@services/Config";

const { width, height } = Dimensions.get("screen");

export default function Cadastro({ navigation }) {
  const { tokenApi, getNewTokenApi } = useContext(AuthContext);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [cpfCnpj, setCpfCnpj] = useState("");
  const [phone, setPhone] = useState("");
  const [showAlert, setShowAlert] = useState({});
  const [checkPrivacity, setCheckPrivacity] = useState(false);
  const [checkTermsOfUse, setCheckTermsOfUse] = useState(false);
  const [loading, setLoading] = useState({ show: false, message: "Logando" });
  const [showMessageModal, setShowMessageModal] = useState(false);

  const [validEmail, setValidEmail] = useState({
    isValid: true,
    invalidMessage: "Digite um email válido",
  });
  const [validPassword, setValidPassword] = useState({
    isValid: true,
    invalidMessage: "Digite um senha forte com minimo de 5 caracteres",
  });
  const [validName, setValidName] = useState({
    isValid: true,
    invalidMessage: "Digite um nome",
  });
  const [validCpfCnpj, setValidCpfCnpj] = useState({
    isValid: true,
    invalidMessage: "Digite um CPF/CNPJ válido",
  });
  const [validPhone, setValidPhone] = useState({
    isValid: true,
    invalidMessage: "Digite um telefone válido",
  });

  if (loading.show) return <Loading message={loading.message} />;

  const onPressMessage = (messageType) => {
    setShowMessageModal(false);
    cadastrar(messageType);
  };

  return (
    <KeyboardAvoidingView
      style={{ flex: 1 }}
      behavior={Platform.OS === "ios" ? "padding" : "height"}
      enabled={true}
    >
      <TouchableWithoutFeedback onPress={!IS_WEB ? Keyboard.dismiss : null}>
        <SafeAreaView style={styles.safeArea}>
          <ScrollView keyboardShouldPersistTaps={"always"}>
            <View style={styles.container}>
              <Image
                source={require("../..//../assets/images/logo-viamais-login.png")}
                style={styles.logoPequeno}
              />

              <Text style={styles.inputLogin}>Faça seu cadastro</Text>
              <CaixaTextoInputIcone
                iconName={"email-outline"}
                placeholderInput={"Email"}
                keyboardType={"email-address"}
                onChangeTextInput={(email) => setEmail(email)}
                maxLength={200}
                value={email}
                textContentType={"username"}
                {...validEmail}
              />

              <CaixaTextoInputIcone
                iconName={"key-outline"}
                placeholderInput={"Senha"}
                onChangeTextInput={(senha) => setPassword(senha)}
                isSenha={true}
                maxLength={80}
                value={password}
                textContentType={"newPassword"}
                {...validPassword}
              />
              <Text
                style={{
                  marginHorizontal: 36,
                  color: Colors.GRAY_DARK,
                  fontSize: Fonts.FONT_SIZE_14,
                  marginTop: -12,
                  marginBottom: 4,
                }}
              >
                {
                  "A senha tem que ter no minimo uma letra maiuscula, uma numero e um caractere especial"
                }
              </Text>
              <CaixaTextoInputIcone
                iconName={"text-account"}
                placeholderInput={"Nome"}
                onChangeTextInput={(nome) => setName(nome)}
                maxLength={300}
                value={name}
                textContentType={"name"}
                {...validName}
              />

              <CaixaTextoInputIcone
                iconName={"file-document-outline"}
                placeholderInput={"CPF ou CNPJ"}
                keyboardType={"numeric"}
                onChangeTextInput={(cpfmask, cpfCnpj) => setCpfCnpj(cpfCnpj)}
                maskInput={Masks.BRL_CPF_CNPJ}
                value={cpfCnpj}
                textContentType="none"
                {...validCpfCnpj}
              />

              <CaixaTextoInputIcone
                iconName={"phone-outline"}
                placeholderInput={"Telefone"}
                keyboardType={"phone-pad"}
                dataDetectorTypes={"phoneNumber"}
                onChangeTextInput={(telefonemask, telefone) =>
                  setPhone(telefone)
                }
                maskInput={Masks.BRL_PHONE}
                value={phone}
                textContentType={"telephoneNumber"}
                {...validPhone}
              />

              {/* <Text style={{ fontSize: Fonts.FONT_SIZE_12, textAlign: 'right', marginTop: -16, marginBottom: 30 }}>Você receberá um e-mail em seguida</Text> */}
              <View
                style={{
                  marginBottom: 16,
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <BouncyCheckbox
                  size={24}
                  fillColor={Colors.ALERT}
                  unfillColor={Colors.WHITE}
                  innerIconStyle={{ borderRadius: 5 }}
                  iconStyle={{ borderRadius: 5 }}
                  textStyle={{
                    textDecorationLine: "none",
                  }}
                  onPress={(checked) => setCheckPrivacity(checked)}
                />
                <Text>{"Li e concordo com a "}</Text>
                <TouchableWithoutFeedback
                  onPress={() => Linking.openURL(urlPrivacity)}
                >
                  <Text style={{ color: Colors.HYPERLINK }}>
                    {"política de privacidade"}
                  </Text>
                </TouchableWithoutFeedback>
              </View>
              <View
                style={{
                  marginBottom: 16,
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <BouncyCheckbox
                  size={24}
                  fillColor={Colors.ALERT}
                  unfillColor={Colors.WHITE}
                  innerIconStyle={{ borderRadius: 5 }}
                  iconStyle={{ borderRadius: 5 }}
                  textStyle={{
                    textDecorationLine: "none",
                  }}
                  onPress={(checked) => setCheckTermsOfUse(checked)}
                />
                <Text>{"Li e concordo com os "}</Text>
                <TouchableWithoutFeedback
                  onPress={() => Linking.openURL(urlTermsOfUse)}
                >
                  <Text style={{ color: Colors.HYPERLINK }}>
                    {"termos de uso"}
                  </Text>
                </TouchableWithoutFeedback>
              </View>
              <Button
                onPress={() => setShowMessageModal(true)}
                textoBotao={"Cadastrar"}
                estilo={styles.button}
              />

              <View style={{ justifyContent: "flex-end" }}>
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    marginTop: 10,
                    marginBottom: 10,
                  }}
                >
                  <View
                    style={{ flex: 1, height: 1, backgroundColor: "black" }}
                  />
                  <View>
                    <Text style={{ width: 50, textAlign: "center" }}>Ou</Text>
                  </View>
                  <View
                    style={{ flex: 1, height: 1, backgroundColor: "black" }}
                  />
                </View>
                <Text
                  style={{
                    fontSize: Fonts.FONT_SIZE_16,
                    textAlign: "center",
                    marginTop: 5,
                  }}
                >
                  Já tem uma conta?
                </Text>
                <Text
                  onPress={() => navigation.navigate("Login")}
                  style={{
                    fontSize: Fonts.FONT_SIZE_22,
                    textAlign: "center",
                    marginTop: 1,
                    fontWeight: "bold",
                  }}
                >
                  Faça Login
                </Text>
              </View>
            </View>
            <BetterAlert {...showAlert} />
            <MessageTypeModal
              show={showMessageModal}
              onPressMessage={(messageValue) => onPressMessage(messageValue)}
            />
          </ScrollView>
        </SafeAreaView>
      </TouchableWithoutFeedback>
    </KeyboardAvoidingView>
  );

  async function cadastrar(messageType) {
    try {
      let valid = true;
      if (!Validade.Email(email.trim())) {
        setValidEmail({ ...validEmail, isValid: false });
        valid = false;
      } else {
        setValidEmail({ ...validEmail, isValid: true });
      }
      if (!Validade.validDocument(cpfCnpj.trim())) {
        setValidCpfCnpj({ ...validCpfCnpj, isValid: false });
        valid = false;
      } else {
        setValidCpfCnpj({ ...validCpfCnpj, isValid: true });
      }
      if (!Validade.Telefone(phone.trim())) {
        setValidPhone({ ...validPhone, isValid: false });
        valid = false;
      } else {
        setValidPhone({ ...validPhone, isValid: true });
      }
      if (password.length < 5) {
        setValidPassword({ ...validPassword, isValid: false });
        valid = false;
      } else {
        setValidPassword({ ...validPassword, isValid: true });
      }
      if (name.length == 0) {
        setValidName({ ...validName, isValid: false });
        valid = false;
      } else {
        setValidName({ ...validName, isValid: true });
      }
      if (!checkPrivacity) {
        valid = false;
        setShowAlert({
          type: "warning",
          title: "Atenção",
          message: "Para criar a conta, aceite os politica de privacidade",
          show: true,
          confirmText: "Vou verificar",
          pressConfirm: () => {
            setShowAlert({ ...showAlert, show: false });
          },
        });
      }

      if (!checkTermsOfUse) {
        valid = false;
        setShowAlert({
          type: "warning",
          title: "Atenção",
          message: "Para criar a conta, aceite os termos de uso",
          show: true,
          confirmText: "Vou verificar",
          pressConfirm: () => {
            setShowAlert({ ...showAlert, show: false });
          },
        });
      }
      
      if (valid) {
        let token = tokenApi;
        if (!token) {
          token = await getNewTokenApi();
        }

        setLoading({ show: true, message: "Cadastrando" });
        let retorno = await Register(
          email.toLowerCase(),
          Encrypt(password.trim()),
          name.trim(),
          Encrypt(cpfCnpj.trim()),
          email.toLowerCase(),
          phone.trim(),
          token,
          messageType
        );
        setLoading({ show: false, message: "Cadastrando" });
        if (retorno.statusCode) {
          navigation.navigate("CodeVerification", {
            codeVerification: retorno.confirmationNumber,
            idUser: retorno.idUser,
            nextPage: "Login",
            email: email,
          });
        } else {
          setShowAlert({
            type: "warning",
            title: "Atenção",
            message: retorno.reason,
            show: true,
            confirmText: "Vou verificar",
            pressConfirm: () => {
              setShowAlert({ ...showAlert, show: false });
            },
          });
        }
      }
    } catch (error) {
      setShowAlert({
        type: "alert",
        title: "Atenção",
        message: error.reason,
        show: true,
        confirmText: "Vou verificar",
        pressConfirm: () => {
          setShowAlert({ ...showAlert, show: false });
        },
      });
    } finally {
      setLoading({ show: false, message: "Cadastrando" });
    }
  }
}

const styles = StyleSheet.create({
  logoPequeno: {
    marginBottom: 10,
    resizeMode: "contain",
    width: 240,
    height: 74,
  },
  inputLogin: {
    fontSize: Fonts.FONT_SIZE_25,
    textAlign: "center",
    marginBottom: 20,
    // fontWeight: Fonts.FONT_BOLD,
    color: Colors.WELCOME_TEXT,
  },
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%",
    paddingVertical: 20,
    backgroundColor: Colors.WHITE,
    marginTop: (height * 0.4) / 8, //StatusBar.currentHeight,
    marginBottom: (height * 0.3) / 8,
  },
  safeArea: {
    flex: 1,
    paddingTop: StatusBar.currentHeight,
    backgroundColor: Colors.WHITE,
  },
  button: {
    width: "70%",
  },
});
